import { call, get } from 'vuex-pathify';
export default {
  computed: {
    moveRotateGeometryEnabled() {
      return (
        this.isAdvancedDigitizingEnabled && this.isMoveRotateGeometryEnabled && this.advancedDigitizingPermissions > 0
      );
    },
    isMoveRotateGeometryEnabled: get('admin/settingsValues@move_rotate_geometry_enabled'),
  },
  data: () => ({
    newGeometry: null,
    isMoveRotateButtonLoading: false,
  }),
  methods: {
    editTopoFeatureAction: call('layers/editTopoDatasourceFeature'),
    editNonTopoFeatureAction: call('layers/editDatasourceFeature'),
    async toggleMoveRotateObject() {
      if (this.isMoveRotateButtonActive) {
        this.turnOffMoveRotateObject();
      } else {
        this.turnOnMoveRotateObject();
      }
    },
    async turnOnMoveRotateObject() {
      this.isMoveRotateButtonLoading = true;
      this.newGeometry = null;
      this.$root.$emit('deactivateAllTools');
      try {
        const featureGeometry = (
          await this.getLayerFeature({ layer_id: this.layerId, feature_id: this.selectedFeatureId })
        )?.geometry;
        this.$root.$emit('turnOnTransformGeometry', {
          geometryValue: featureGeometry,
          settings: {
            hitTolerance: 0,
            translateBBox: true,
            // scale: true,
          },
          transformendCallback: this.onMoveRotateDrawEnd,
        });
        this.isMoveRotateButtonActive = true;
      } finally {
        this.isMoveRotateButtonLoading = false;
      }
    },
    onMoveRotateDrawEnd(e) {
      this.newGeometry = e?.geometry || null;
    },
    turnOffMoveRotateObject() {
      this.$root.$emit('turnOnTransformGeometry');
      this.isMoveRotateButtonActive = false;
    },
    moveRotateGeometryHandler() {
      if (!this.newGeometry) {
        this.turnOffMoveRotateObject();
        return;
      }
      if (this.isTopo) {
        this.moveRotateTopoFeature({ geomName: 'geometry' });
      } else {
        this.moveRotateNonTopoFeature({ geomName: this.geometryPropertyName });
      }
    },
    async moveRotateTopoFeature({ geomName } = {}) {
      const r = await this.moveRotateFeatureHandler({
        editAction: this.editTopoFeatureAction,
        geomName,
      });
      this.$root.$emit(
        'refreshMvtSources',
        r.data.data.map(layer => ({ id: layer, group: 'layers' })),
        true
      );
    },
    async moveRotateNonTopoFeature({ geomName } = {}) {
      await this.moveRotateFeatureHandler({
        editAction: this.editNonTopoFeatureAction,
        geomName,
      });
      this.$root.$emit('refreshMvtSource', this.layerId);
    },
    async moveRotateFeatureHandler({ editAction, geomName } = {}) {
      this.isMoveRotateButtonLoading = true;
      try {
        const editPayload = {
          datasource: this.datasource,
          id: this.selectedFeatureId,
          body: {
            [geomName]: this.newGeometry,
            properties: {},
          },
          params: { layer_id: this.layerId },
        };
        const r = await editAction(editPayload);
        return r;
      } finally {
        this.turnOffMoveRotateObject();
        this.$root.$emit('refreshTableData');
        this.$root.$emit('refreshFormData');
        this.isMoveRotateButtonLoading = false;
      }
    },
  },
};
